import { render } from "./mread.vue?vue&type=template&id=8d1fc5d0&scoped=true"
import script from "./mread.vue?vue&type=script&lang=js"
export * from "./mread.vue?vue&type=script&lang=js"

import "./mread.vue?vue&type=style&index=0&id=8d1fc5d0&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1fc5d0"]])

export default __exports__